import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import FormControl from "@mui/material/FormControl";
import OutlinedInput from "@mui/material/OutlinedInput";
import FormLabel from "@mui/material/FormLabel";
import { Typography, InputAdornment } from "@mui/material";
import "./style.css";

const PlainTextField = forwardRef((props, ref, ...rest) => {
    const [inputValue, setInputValue] = useState(props.value);
    const [hasError, setHasError] = useState(false);

    useImperativeHandle(ref, () => ({
        validate() {
            return isValidData();
        },
    }));

    const isValidData = () => {
        if (props.isRequired) {
            if (inputValue != "" && inputValue != undefined) {
                setHasError(false);
                return !false;
            } else {
                setHasError(true);
                return !true;
            }
        } else {
            setHasError(false);
            return !false;
        }
    };

    const handleChange = (event) => {
        event.stopPropagation();
        event.preventDefault();
        let newValue = event.target.value;
        console.log(newValue);
        setInputValue(newValue);
        props.onChange(newValue);
        props.isRequired ? (newValue?.length > 0 ? setHasError(false) : setHasError(true)) : setHasError(false);
    };

    const validateInput = (event) => {
        if (props.isRequired) {
            if (inputValue?.trim() === "" || inputValue === undefined) {
                setHasError(true);
            }

            props.onChange(inputValue);
            if (props.onBlur) {
                props.onBlur(inputValue);
            }
        } else {
            setHasError(false);
            if (props.onBlur) {
                props.onBlur(inputValue);
            }
        }
    };

    const removeValidate = (event) => {
        setHasError(false);
    };

    return (
        <div>
            <FormControl {...rest} sx={{ my: 2 }} fullWidth variant="outlined">
                <FormLabel htmlFor="my-input">
                    <Typography variant="subtitle1" sx={{ color: "text.primary" }}>
                        {props.label}
                        {props.isRequired && props.label ? <span style={{ color: "#0080ff" }}>*</span> : ""}
                    </Typography>
                </FormLabel>

                <OutlinedInput
                    {...rest}
                    variant="standard"
                    type={props.type}
                    readOnly={props.readOnly}
                    id={props.id}
                    sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                            border: props.readOnly ? "none" : "1px solid #d6d6d6",
                        },
                        "&:hover > .MuiOutlinedInput-notchedOutline": {
                            border: props.readOnly ? "none" : "1px solid #d6d6d6",
                        },
                    }}
                    inputProps={{
                        min: 0,
                        style: { textAlign: props.alignCenter ? "center" : "start" },
                        sx: {
                            color: "#000",
                            fontSize: "0.8rem",
                            fontWeight: 400,
                            "&::placeholder": {
                                color: "gray",
                                fontSize: "0.75rem",
                                opacity: 1, // otherwise firefox shows a lighter color
                                input: {
                                    border: "none",
                                },
                            },
                        },
                    }}
                    required={props.isRequired}
                    multiline={props.multiline}
                    minRows={props.minRows}
                    maxRows={props.maxRows}
                    min={props.min ? props.min : undefined}
                    value={inputValue}
                    autoFocus={props.isAutoFocus}
                    onChange={handleChange}
                    onBlur={validateInput}
                    placeholder={props.placeholder}
                    startAdornment={
                        props.prefix ? <InputAdornment position="start">{props.prefix}</InputAdornment> : ""
                    }
                    error={hasError}
                    helperText="There has been an error"
                />
            </FormControl>
        </div>
    );
});

export default PlainTextField;
